import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import ContentBlockParam from '../../../../../../components/Layout/ContentBlockParam';

const BusinessInvolvements: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.generalInfoBox}>
      <ContentBlock title={t(`companies:companyIssues:bi:businessInvolvement`)}>
        <Box className={classes.cellContainer}>
          <Box className={classes.itemsBlock}>
            <Grid className={classes.item}>
              <ContentBlockParam
                label={t('companies:companyIssues:bi:businessInvolved')}
                value={'-'}
              />
            </Grid>
          </Box>
        </Box>
      </ContentBlock>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  generalInfoBox: {
    width: '100%',
    marginRight: theme.spacing(8),
    display: 'flex',
  },
  cellContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  itemsBlock: {
    display: 'flex',
    flexDirection: 'row',
  },
  item: {
    padding: theme.spacing(5),
    flexGrow: 1,
    flexBasis: 0,
  },
}));

export default BusinessInvolvements;
